<div class="modal-header">
  <button type="button" (click)="onClickClose()" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button>
  <h4 class="modal-title" [class.text-center]="centered">{{ titulo }}</h4>
</div>
<div class="modal-body">
  <div class="row" [class.text-center]="centered">
    <div class="col-xs-12">
      <h4 *ngIf="mensagem">{{ mensagem }}</h4>
      <span *ngIf="rawMessage" [innerHTML]="rawMessage"></span>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button *ngIf="showFecharBtn" type="button" class="btn btn-border-orange pull-left" (click)="onClickClose()">{{ labelFechar }}</button>
  <button *ngIf="showOkBtn" type="button" class="btn btn-full-orange pull-right" (click)="onClickOk()">{{ labelOk }}</button>
</div>
